const RE = /([^A-Za-z0-9_\-\s()@£$%])/;

const namesRequiresCleansing = (name: string): boolean => {
  return RE.test(name);
};

export default namesRequiresCleansing;
